import React from 'react';
import Hero from './components/Download/Hero';
import Main from './components/Download/Main';

const Download = () => {
    return (
        <div>
            <Hero />
            <Main />
        </div>
    )
}

export default Download;